import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type PrintsState, type PrintsActionTypes } from 'app/store/types';

const initialState: PrintsState = {};

const printsReducer = (state = initialState, action: PrintsActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { prints },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(prints && { byId: prints }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'prints',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	printsReducer,
);

// Selectors
export const getPrintsById = ({ app: { selectedLicenseGroupId }, prints }: RootState) =>
	prints[selectedLicenseGroupId].byId;

export const getPrints = createSelector([getPrintsById], (printsById) => Object.values(printsById));
